import React from 'react';
import styled from 'styled-components';
import { SwipeableDrawer, SwipeableDrawerProps } from '@material-ui/core';

export type DrawerProps = Omit<SwipeableDrawerProps, ''>;

const Drawer: React.FC<DrawerProps> = (props) => {
  return (
    <StyledWrapperDrawer
      className="wrap_components_drawer"
      {...props}
    >
      {props.children}
    </StyledWrapperDrawer>
  );
};

const StyledWrapperDrawer = styled(SwipeableDrawer)`
  margin-top: 80px;
  @media (max-width: 590px) {
      margin-top: 60px;
  }
  position: relative;

  & .MuiPaper-root {
    background: rgba(1,5,14,0.9);
    overflow-y: unset !important;
    overflow: hidden;
    top: 80px;
    @media (max-width: 590px) {
      top: 60px !important;
    }
  }
  & .MuiPaper-root::-webkit-scrollbar {
    width: 0;
  }
  & .MuiBackdrop-root {
    top: 80px;
    @media (max-width: 590px) {
      top: 60px !important;
    }
  }
`;

export default Drawer;
